import { motion } from 'framer-motion'
import {Truck, Ship, Plane, Check} from 'lucide-react'

const SERVICES = [
  {
    id: 'ltl',
    icon: Truck,
    title: 'Less Than Truckload (LTL)',
    blurb:
      'LTL shipping consolidates multiple smaller freight loads onto a single truck, so you only pay for the space your pallets occupy. It is the most cost-effective option for palletized B2B shipments between 150 and 15,000 lbs.',
    points: [
      'Priced by weight, freight class, and lane distance',
      'Ideal for 1-6 pallets that do not fill a full trailer',
      'Accessorials: liftgate, residential, and hazmat surcharges',
    ],
  },
  {
    id: 'ocean',
    icon: Ship,
    title: 'Ocean Freight Rates',
    blurb:
      'Work with global ocean freight forwarders for both FCL and LCL moves. Full Container Load bills a flat rate per 20ft/40ft container, while Less than Container Load is calculated per cubic meter (CBM) of cargo volume.',
    points: [
      'FCL: flat rate per standard container',
      'LCL: billed per CBM, ideal for partial loads',
      'Port-to-port and door-to-door options',
    ],
  },
  {
    id: 'air',
    icon: Plane,
    title: 'International Air Freight Services',
    blurb:
      'Premium global transport for time-critical cargo. International air freight is priced on the greater of dimensional or actual weight, delivering the fastest transit times across intercontinental lanes.',
    points: [
      'Chargeable weight = greater of dim or actual weight',
      'Fastest transit for high-value, urgent cargo',
      'Consolidated and express air cargo rates',
    ],
  },
]

function Services() {
  return (
    <section id="services" className="bg-[#F1F5F9] py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-wider text-[#10B981]">
            Freight Services
          </span>
          <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold text-[#0F172A] tracking-tight">
            Full-service B2B logistics coverage
          </h2>
          <p className="mt-3 text-slate-600 text-lg">
            From regional truck freight to intercontinental air and ocean lanes, estimate and book the mode that fits your cargo.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              id={s.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-7 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#1E293B] text-white">
                <s.icon className="w-6 h-6" />
              </span>
              <h3 className="mt-5 text-xl font-bold text-[#0F172A]">{s.title}</h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.blurb}</p>
              <ul className="mt-5 space-y-2.5">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
                    <Check className="w-4 h-4 text-[#10B981] mt-0.5 shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
